import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { Shell } from '../components/Article';
import { PAGES } from './ContentPage';

// Served by Apache as build/404.html (with a real 404 status) for unknown URLs.
const NotFound = () => (
  <Shell>
    <Seo title="Page not found — Emboscale" description="This page doesn't exist or has moved." noindex />
    <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white mt-8 mb-4">Page not found</h1>
    <p className="mb-8">This page doesn't exist or has moved. These might be what you were looking for:</p>
    <ul className="space-y-2 [&_a]:text-emerald-600 dark:[&_a]:text-emerald-400">
      <li><Link to="/">The Factory Agent (home)</Link></li>
      <li><Link to="/blog/">Blog</Link></li>
      {PAGES.map((p) => (
        <li key={p.path}><Link to={`${p.path}/`}>{p.label}</Link></li>
      ))}
    </ul>
  </Shell>
);

export default NotFound;
